import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Complaints from "@/pages/Complaints";
import ComplaintDetail from "@/pages/ComplaintDetail";
import CorrectiveActions from "@/pages/CorrectiveActions";
import { Clients, Suppliers } from "@/pages/CrudPages";
import Statistics from "@/pages/Statistics";
import Settings from "@/pages/Settings";
import { Toaster } from "sonner";

/** Redirige /reclamations/:id vers /litiges/:id en conservant l'identifiant. */
function RedirectionLitige() {
  const { id } = useParams();
  return <Navigate to={`/litiges/${id}`} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/litiges" element={<Complaints />} />
                <Route path="/litiges/:id" element={<ComplaintDetail />} />
                {/* Anciennes URL : redirigees plutot que supprimees, pour que
                    les favoris et les liens deja envoyes par email continuent
                    de fonctionner. `replace` evite d'empiler l'ancienne URL
                    dans l'historique du navigateur. */}
                <Route path="/reclamations" element={<Navigate to="/litiges" replace />} />
                <Route path="/reclamations/:id" element={<RedirectionLitige />} />
                {/* Modules retires du produit. Sans ces redirections, un ancien
                    favori affichait la coquille de l'application sans contenu :
                    une page blanche, que l'utilisateur lit comme une panne. Les
                    ecrans ne sont PAS reintroduits — seul le chemin retombe sur
                    le module qui les remplace. */}
                <Route path="/non-conformites" element={<Navigate to="/litiges" replace />} />
                <Route path="/receptions" element={<Navigate to="/litiges" replace />} />
                <Route path="/actions" element={<CorrectiveActions />} />
                <Route path="/fournisseurs" element={<Suppliers />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/statistiques" element={<Statistics />} />
                <Route path="/parametres" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
